package com.islamicmedia.site.components

import androidx.compose.runtime.Composable
import com.islamicmedia.shared.domain.model.HadithReference
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun HadithReferenceBox(
    reference: HadithReference
) {
    Div(attrs = {
        style {
            paddingTop(14.px)
            property("border-top", "1px solid rgba(0, 0, 0, 0.06)")
            marginTop(14.px)
        }
    }) {
        Div(attrs = {
            style {
                fontWeight(700)
                fontSize(14.px)
                color(HadithTextDark)
                marginBottom(12.px)
            }
        }) { Text("Hadith Reference") }

        P(attrs = {
            style {
                property("direction", "rtl")
                property("text-align", "right")
                property("font-family", "'Digital Khatt', 'Traditional Arabic', 'Scheherazade', serif")
                fontSize(24.px)
                lineHeight(40.px)
                color(Gray900)
                margin(0.px, 0.px, 12.px)
                fontWeight(400)
            }
        }) { Text(reference.arabic) }

        P(attrs = {
            style {
                fontSize(14.px)
                property("font-style", "italic")
                color(Gray600)
                margin(0.px, 0.px, 8.px)
                lineHeight(1.7.em)
            }
        }) { Text("\"${reference.english}\"") }

        Div(attrs = {
            style {
                fontSize(13.px)
                fontWeight(600)
                color(HadithTextDark)
                backgroundColor(rgba(255, 255, 255, 0.7))
                borderRadius(RadiusFull.unsafeCast<CSSNumeric>())
                padding(4.px, 14.px)
                property("display", "inline-block")
                property("backdrop-filter", "blur(4px)")
            }
        }) { Text(reference.reference) }
    }
}
